'use strict';

angular.module('amexReconciliationApp')
  .directive('transactionSortableColumnHeader', function transactionColumnHeader(TransactionSortModel, TransactionFieldModel, AnalyticsService) {
    return {
      restrict: 'A',
      link: function(scope, element, attributes) {
        var sortColumnName = attributes.transactionSortableColumnHeader;
        var iconColumnHeaderNames = [
          'Lock Status (Icon)',
          'Status (Icon)',
          'Exception (Icon)',
          'LID (Icon)',
          'Comment (Icon)',
          'Approvals (Icon)',
          'Receipts (Icon)',
          'Linked/Matched (Icon)'
        ].map(function(value) {
          return value.toLowerCase();
        });

        if(!(iconColumnHeaderNames.indexOf(sortColumnName) >= 0)) {
          var icon = angular.element('<span class="fa"></span>');
          icon.attr('class', 'fa fa-sort');

          element.on('click', function () {
            TransactionSortModel.setSortField(sortColumnName);

            AnalyticsService.logTransactionSorting(sortColumnName);
          });
          element.append(icon);
          element.addClass('sortable-column-header-transactions');
          TransactionSortModel.onSortOrderChanged(scope, updateIconClass);
        }

        /*function onCustomizableFieldChange() {
          if (TransactionSortModel.sortField() === 'customizable') {
            icon.attr('class', 'fa fa-sort');
          }
        }

        function onMerchantDropdownValueChange() {
            icon.attr('class', 'fa fa-sort');
        }*/

        function sortingClass(sortInfo) {
          if (sortInfo.field !== sortColumnName) {
            return 'fa-sort';
          }

          return sortInfo.direction === 'asc' ? 'fa-caret-up' : 'fa-caret-down';
        }

        function updateIconClass(sortInfo) {
          icon.attr('class', 'fa ' + sortingClass(sortInfo));
        }
      }
    };

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/transactionSortableColumnHeader.js
// module id = 539
// module chunks = 0